import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';

import BackdropLoading from './../commons/BackdropLoading';
import DialogPayments from './../dialog/DialogPayments';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

class SubscriptionViewPayments extends React.Component {

  constructor (props) {
    super(props);
    this._isMounted = false; // isMounted React pattern to avoid memory leaks
    this.state = {
      loading: false,
      openDialog_list: false,
    };
  }

  componentDidMount () {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  change () {
    this._isMounted && this.setState({ openDialog_list: true });
  }

  render () {
    const { classes, className } = this.props;
    const { loading } = this.state;
    return (
      <Box className={clsx(classes.root, className && className.root)}>
        <BackdropLoading open={loading} />
        { this.renderContent() }
        { this.renderDialogs() }
      </Box>
    );
  }

  renderContent () {
    const { classes, subscription } = this.props;
    if (!subscription) {
      return null;
    }

    return (
      <Box className={classes.content}>
        <Box className={classes.actions}>
          <Button color="quaternary" className={classes.action} onClick={() => this._isMounted && this.setState({openDialog_list: true})}>Historique des paiements</Button>
        </Box>
      </Box>
    );

  }

  renderDialogs () {
    const { subscription } = this.props;
    if (!subscription) {
      return null;
    }
    return (
      <React.Fragment>
        { this.state.openDialog_list && (
          <DialogPayments
            open={this.state.openDialog_list}
            query={{id_subscription: subscription.ID}}
            onError={this.props.onError}
            onClose={ () => this._isMounted && this.setState({openDialog_list: false}) }
          />
        ) }
      </React.Fragment>
    );
  }
}

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderBottom: `1px solid ${theme.palette.tertiary.main}`,
  },
  title: {},
  actions: {},
  action: {
    width: '100%',
  }
});

SubscriptionViewPayments.propTypes = {
  subscription: PropTypes.object.isRequired,
  onError: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(SubscriptionViewPayments);
